export const ACCOUNT_ENUM = {
    ROLE_SELECTION: 'ROLE_SELECTION',
    LOBBY: 'LOBBY',
    GAME: 'GAME',
    AUDIENCE: "AUDIENCE",
    TIMER: "TIMER",
    EMPTY_QUIZ: "EMPTY_QUIZ"
}